namespace advisorop.components.advisor {

    export class ManualAccountsExportController {

        accounts: domains.IManualAccountExport[];
        ppTransactionsForAccount: {
            [accountId: string]: domains.IManualAccountExport[];
        } = {};
        ppTransactions: domains.IManualAccountExport[] = [];
        updateFrequencies: Array<domains.ILOV> = [];
        mainPanel: widgets.AdvisoropPanelController;
        dgRowsForSaving = [];
        // allocationRule: any = { type: "range", min: 0, max: 1, message: "Please enter value between 0 (0.00%) and 1 (100.00%)" };
        dg: DevExpress.ui.dxDataGridOptions;
        dgManualAccountsGrid: DevExpress.ui.dxDataGrid;
        dgsExportForAccount: { [accountId: string]: DevExpress.ui.dxDataGrid; } = {};
        dgExport: DevExpress.ui.dxDataGridOptions;
        advisoryFirms: domains.IAdvisoryFirm[];
        selFirm: domains.IAdvisoryFirm;

        isInitializing: boolean = false;
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#manualAccountsExportContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading data...",
            bindingOptions: {
                visible: "vm.isInitializing"
            }
        }

        static $inject = ["servicerService", "generalService", "advisoryFirmApi"];
        constructor(private servicerService: services.ServicerService,
            private gs: services.GeneralService,
            private advisoryFirmApi: services.AdvisoryFirmApi) {

            this.dg = {
                bindingOptions: {
                    dataSource: "vm.accounts",
                },
                keyExpr: "accountId",
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "4350px",
                paging: { enabled: true, pageSize: 50 },
                //scrolling: {
                //    useNative: true
                //},
                //height: "400px", 
                //paging: {
                //    enabled: false,
                //    pageSize: 225
                //},
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                editing: {
                    mode: "batch",
                    allowUpdating: false
                },
                columns: [
                // columns for editing
                    { dataField: "investors", caption: "Investor", allowExporting: false, allowEditing: false, width: 100 },
                    { dataField: "accountId", caption: "", cellTemplate: "colActions", width: 30 },
                    { dataField: "accountNumber", caption: "Account Number", allowEditing: false, width: 100 },
                    { dataField: "accountName", caption: "Account Name", allowEditing: false, allowExporting: false, width: 140 },
                    { dataField: "productDescription", caption: "Product Description", allowEditing: false, minWidth: 140 },
                    {
                        caption: "Update Frequency", calculateCellValue: data => this.calcUpdateFrequency(data), width: 114
                    },
                    { dataField: "lastUpdate", caption: "Last Update", dataType: "date", alignment: "center", allowEditing: false, width: 70, sortIndex: 1, sortOrder: "desc" },
                    { dataField: "lastValue", caption: "Last Value", dataType: "number", format: "currency", allowEditing: false, width: 65 },
                    { dataField: "lastExported", caption: "Last Exported", dataType: "date", format: { type: "shortDate" }, allowEditing: false, width: 70 },
                    {
                        dataField: "newDate", caption: "New Date",
                        //format: { type: "shortDate" },
                        format: {
                            parser: function (value) {
                                let parts = value.split('/');
                                if (3 !== parts.length) {
                                    return;
                                }
                                return new Date(parts[2].length < 3 ? Number('20' + parts[2]) : Number(parts[2]), Number(parts[0]) - 1, Number(parts[1]))
                            },
                            formatter: function (value) {
                                return DevExpress.localization.formatDate(new Date(value.toString()), 'shortdate');
                            }
                        },
                        dataType: "date",
                        alignment: "center",
                        allowEditing: true, // validationRules: [this.allocationRule],
                        minWidth: 45,
                        width: 70,
                        sortIndex: 0,
                        sortOrder: "asc"
                    },
                    { dataField: "accountId", caption: "", cellTemplate: "colAddTransaciton", width: 30 },
                ],
                export: {
                    enabled: false,
                },
                masterDetail: {
                    enabled: false,
                    template: "transactionDetails"
                },
                onInitialized: (e) => {
                    this.dgManualAccountsGrid = e.component;
                },
            }

            this.dgExport = {
                bindingOptions: {
                    dataSource: "vm.ppTransactions",
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "4350px",
                paging: { enabled: false },

                columns: [
                    { dataField: "ppAccountNumber", caption: "Portfolio Pathway Account Number", width: 300, visible: true },
                    { dataField: "accountNumber", caption: "Account Number", width: 150, visible: true },
                    {
                        caption: "Action", width: 80, visible: true,
                        calculateCellValue: data => this.calcActionTt(data, false)
                    },
                    {
                        dataField: "tradeType", caption: "Trade Type", visible: true,
                        calculateCellValue: data => this.calcActionTt(data, true)
                    },
                    {
                        dataField: "newDate", caption: "Trade Date", visible: true,
                        calculateCellValue: data => this.calcTradeDate(data)
                    },
                    {
                        dataField: "newDate", caption: "Settle Date", visible: true,
                        calculateCellValue: data => this.calcTradeDate(data)
                    },
                    {
                        dataField: "security", caption: "Security", visible: true,
                        calculateCellValue: data => "PERFORMANCE CONVERSION"
                    },
                    {
                        caption: "SecTy", visible: true,
                        calculateCellValue: data => "pp"
                    },
                    {
                        dataField: "securityId", caption: "SECID", visible: true,
                        calculateCellValue: data => "PerfConv"
                    },
                    {
                        caption: "Amount",
                        dataType: "number",
                        format: { precision: 2, type: "decimal" },
                        visible: true,
                        calculateCellValue: data => this.calcAmount(data)
                    }, {
                        dataField: "units", caption: "Units", dataType: "number", format: { precision: 2, type: "decimal" }, visible: true,
                        calculateCellValue: data => this.calcAmount(data)
                    }, {
                        caption: "SrcDest", visible: true,
                        calculateCellValue: data => {
                            if (data.contributions || data.withdrawals) {
                                return "CLIENT";
                            }
                        }
                    },
                    { dataField: "excludeTrade", caption: "Exclude Trade (Y/N)", visible: true },
                    { dataField: "comment", caption: "Comment", visible: true },
                    { dataField: "notes", caption: "Notes", visible: true },
                ],
                export: {
                    enabled: true,
                    fileName: "manualaccounts",
                    allowExportSelectedData: false,
                    texts: {
                        exportSelectedRows: "Export PP transactions",
                        exportAll: "Export accounts"
                    },
                    customizeExcelCell: (options) => this.customizeExport(options)
                },
                onExporting: (e) => {
                },
                onExported: function (e) {
                },
                onRowUpdated: (e) => {
                }
            }
        }

        customizeExport = (options: any) => {
            try {
                let gridCell = options.gridCell as DevExpress.excelExporter.ExcelDataGridCell;
                if (!gridCell) {
                    return;
                }
                options.font.size = 12;
                options.font.name = "Arial";
                if (gridCell.column.dataField === "ppAccountNumber" || gridCell.rowType === "header") {
                    options.font.bold = true;
                    options.backgroundColor = '#EFEFEF';
                    // options.font.color = '#000000';
                }
            } catch (e) {

            }
        }

        calcUpdateFrequency(data: any) {
            let freq = this.updateFrequencies.filter(v => v.value == data.updateFrequency);

            return freq.length > 0 ? freq[0].name : "Undefined";
        }

        calcActionTt(data: any, tt: boolean) {
            if (data.newValue) {
                var lastValue: number = data.lastValue;
                // if we have more than 1 update for this account then determine lastValue from prior updates
                if (this.ppTransactionsForAccount[data.accountId].length > 1) {
                    // Find the trasaction with date just prior to this one
                    const dataNewDate = new Date(data.newDate);
                    var rowLessThan = this.ppTransactionsForAccount[data.accountId].filter(f => new Date(f.newDate) < dataNewDate);
                    if (rowLessThan.length > 0)
                        lastValue = rowLessThan.sort((a, b) => new Date(b.newDate).getTime() - new Date(a.newDate).getTime())[0].newValue;
                }
                var amount = data.newValue - (lastValue || 0);
                if (tt) {
                    return (amount > 0) ? "61" : "62";
                } else {
                    return (amount > 0) ? "li" : "lo";
                }
            } else if (data.contributions) {
                return tt ? "33" : "by";
            } else if (data.withdrawals) {
                return tt ? "34" : "sl";
            }
        }

        calcAmount(data: any) {
            if (data.newValue) {
                var lastValue: number = data.lastValue;
                // if we have more than 1 update for this account then determine lastValue from prior updates
                if (this.ppTransactionsForAccount[data.accountId].length > 1) {
                    // Find the trasaction with date just prior to this one
                    const dataNewDate = new Date(data.newDate);
                    var rowLessThan = this.ppTransactionsForAccount[data.accountId].filter(f => new Date(f.newDate) < dataNewDate);
                    if (rowLessThan.length > 0)
                        lastValue = rowLessThan.sort((a, b) => new Date(b.newDate).getTime() - new Date(a.newDate).getTime())[0].newValue;
                }
                return Math.abs(data.newValue - (lastValue || 0));
            } else if (data.contributions) {
                return data.contributions;
            } else if (data.withdrawals) {
                return data.withdrawals;
            }
        }

        calcTradeDate(data: any) {
            // 7/31/2019
            if (data.newValue) {
                // console.log(`New date ${typeof (data.newDate)}:`, data.newDate, data);
                var tradeDate = new Date(Date.now());
                if (data.newDate) {
                    tradeDate = new Date(data.newDate);
                }
                // console.log(`Trade date: `, tradeDate);
                //return `${tradeDate.getDate()}/${tradeDate.getMonth()+1}/${tradeDate.getFullYear()}`; // data.newDate;
                return `${tradeDate.getMonth() + 1}/${tradeDate.getDate()}/${tradeDate.getFullYear()}`; // data.newDate;
            } else if (data.contributions || data.withdrawals) {
                var tradeDate = new Date(Date.now());

                // If we have more than 1 update for this account, look at the other updates to determine the trade date
                // for this contribution or withdrawal. If no other update exists before this update, use the last update date
                var useLastUpdate: boolean = false;
                if (this.ppTransactionsForAccount[data.accountId].length > 1) {
                    // Find the trasaction with date just prior to this one
                    //console.log("Looking for rows less than", data.newDate);
                    const dataNewDate = new Date(data.newDate);
                    var rowLessThan = this.ppTransactionsForAccount[data.accountId].filter(f => new Date(f.newDate) < dataNewDate);
                    if (rowLessThan.length == 0)
                        useLastUpdate = true;
                    else {
                        //console.log("rowLessThan", rowLessThan);
                        var priorNewDate = new Date(rowLessThan.sort((a, b) => new Date(b.newDate).getTime() - new Date(a.newDate).getTime())[0].newDate);
                        //console.log("priorNewDate", priorNewDate);
                        if (priorNewDate.getFullYear() > 1970) {
                            priorNewDate.setDate(priorNewDate.getDate() + 1);
                            tradeDate = priorNewDate;
                        }
                    }
                } else {
                    useLastUpdate = true;
                }

                if (useLastUpdate) {
                    //console.log(`Last update ${typeof (data.lastUpdate)}:`, data.lastUpdate);
                    var tmp = new Date(data.lastUpdate);
                    // if minimal date then we probably needs to show NOTHING or CURRENT DATE
                    if (tmp.getFullYear() > 1970) {
                        tmp.setDate(tmp.getDate() + 1);
                        tradeDate = tmp;
                    }
                }
                //return `${tradeDate.getDate()}/${tradeDate.getMonth() + 1}/${tradeDate.getFullYear()}`; // data.newDate;
                return `${tradeDate.getMonth() + 1}/${tradeDate.getDate()}/${tradeDate.getFullYear()}`; // data.newDate;
            }
        }

        getTransactionGrid = (accountId: string) => {
            return {
                bindingOptions: {
                    dataSource: "vm.ppTransactionsForAccount[item.data.accountId]"
                },
                columns: [
                    // columns for editing
                    {
                        dataField: "newDate", caption: "New Date",
                        //format: { type: "shortDate" },
                        format: {
                            parser: function (value) {
                                let parts = value.split('/');
                                if (3 !== parts.length) {
                                    return;
                                }
                                return new Date(parts[2].length < 3 ? Number('20' + parts[2]) : Number(parts[2]), Number(parts[0]) - 1, Number(parts[1]))
                            },
                            formatter: function (value) {
                                return DevExpress.localization.formatDate(new Date(value.toString()), 'shortdate');
                            }
                        },
                        dataType: "date",
                        alignment: "center",
                        allowEditing: true, // validationRules: [this.allocationRule],
                        sortIndex: 0, sortOrder: "asc"
                    },
                    {
                        dataField: "newValue", caption: "New Value",
                        dataType: "number",
                        //format: { precision: 2, type: "decimal" },
                        format: "currency",
                        allowEditing: true, // validationRules: [this.allocationRule],
                    }, {
                        dataField: "contributions", caption: "Contributions",
                        dataType: "number",
                        format: "currency",
                        allowEditing: true, // validationRules: [this.allocationRule],
                    }, {
                        dataField: "withdrawals", caption: "Withdrawals",
                        dataType: "number",
                        //format: { precision: 2, type: "decimal" },
                        format: "currency",
                        allowEditing: true, // validationRules: [this.allocationRule],
                    },
                ],
                editing: {
                    mode: "cell",
                    allowUpdating: true,
                    allowAdding: true,
                    allowDeleting: true,
                },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                columnMinWidth: 45,
                allowColumnReordering: false,
                allowColumnResizing: true,
                onInitialized: (e) => {
                    this.dgsExportForAccount[accountId] = e.component;
                },
                onInitNewRow: (e) => {
                    this.onTransactionRowAdding(e);
                },
                onRowRemoved: (e) => {
                    this.onTransactionRowDeleted(e);
                },
            }
        }

        /**
         * report: AssetAllocation, Holdings, Performance, Transactions
         * level: will always be A-account or S-sleeve account
         * */
        openReport = (report: string, level: string, account: any) => {
            // console.log(`Report: ${report} Level ${level}, account: ${account}`);
            this.servicerService.calculateOrionParamsAsync(level, account.accountId).then(params => {
                this.servicerService.openOrionReport(report, params);
            });
        }

        addTransactions = (item: any) => {
            if (this.ppTransactionsForAccount[item.data.accountId] == undefined)
                this.ppTransactionsForAccount[item.data.accountId] = [];
            var transaction = { ...item.data }
            if (!this.dgManualAccountsGrid.isRowExpanded(item.key))
                this.dgManualAccountsGrid.expandRow(item.key);
            else
                transaction.newDate = this.calcNewDate(item.data.accountId, item.data.updateFrequency);
            this.ppTransactionsForAccount[item.data.accountId].push(transaction);
        }

        calcNewDate(key: any, updateFrequency: domains.UpdateFrequency): Date {
            var currentDate = this.ppTransactionsForAccount[key].reduce((transactionWithLatestDate, currentTransaction) => (transactionWithLatestDate == null ? currentTransaction : (transactionWithLatestDate.newDate > currentTransaction.newDate ? transactionWithLatestDate : currentTransaction)), null).newDate;            var tmp = new Date(currentDate);
            switch (+updateFrequency) {
                case domains.UpdateFrequency.UNDEFINED:
                    tmp.setDate(tmp.getDate() + 1);
                    break;
                case domains.UpdateFrequency.DAILY:
                    tmp.setDate(tmp.getDate() + 1);
                    break;
                case domains.UpdateFrequency.BI_MONTHLY:
                    var monthsWith31Days = [1, 3, 5, 7, 8, 10, 12];
                    var daysToAdd = 15;
                    if (tmp.getDate() < 15) {
                        if (tmp.getMonth() == 2 && tmp.getDate() > 13) {
                            daysToAdd = 15 - (tmp.getDate() - 13)
                        }
                    } else if (monthsWith31Days.includes(tmp.getMonth())) {
                        daysToAdd = 16;
                    }
                    tmp.setDate(tmp.getDate() + daysToAdd);
                    break;
                case domains.UpdateFrequency.MONTHLY:
                    if (tmp.getMonth() == 0 && tmp.getDate() > 28) {
                        tmp.setFullYear(tmp.getFullYear(), 1, 28);
                    } else {
                        tmp.setMonth(tmp.getMonth() + 1);
                    }
                    break;
                case domains.UpdateFrequency.QUARTERLY:
                    if (tmp.getMonth() == 10 && tmp.getDate() > 28) {
                        tmp.setFullYear(tmp.getFullYear() + 1, 1, 28);
                    } else {
                        tmp.setMonth(tmp.getMonth() + 3);
                    }
                    break;
                case domains.UpdateFrequency.BI_ANNUALLY:
                    if (tmp.getMonth() == 7 && tmp.getDate() > 28) {
                        tmp.setFullYear(tmp.getFullYear() + 1, 1, 28);
                    } else {
                        tmp.setMonth(tmp.getMonth() + 6);
                    }
                    break;
                case domains.UpdateFrequency.ANNUALLY:
                    tmp.setFullYear(tmp.getFullYear() + 1);
                    break;
            }
            return tmp;
        }

        onTransactionRowAdding = (e: any) => {
            var acc = this.accounts.find(a => a.accountId == e.model.item.key);
            e.data = { ...acc };
            e.data.newDate = this.calcNewDate(e.model.item.key, acc.updateFrequency);
            //console.log("Adding Transaction");
        }

        onTransactionRowDeleted = (e: any) => {
            if (this.ppTransactionsForAccount[e.model.item.key].length == 0) {
                this.dgManualAccountsGrid.collapseRow(e.model.item.key);
            }
            //console.log("Transaction Deleted");
        }

        loadManualAccounts(advisoryFirmId: number): void {
            // this.showLoadingPanel();
            this.isInitializing = true;
            this.servicerService.getManualAccountsForExport(advisoryFirmId)
                .then(resp => {
                    this.accounts = resp.data;
                    this.isInitializing = false;
                }, err => this.gs.showError(err))
                .finally(() => {
                    this.isInitializing = false;
                    this.hideLoadingPanel();
                });
        };

        showLoadingPanel() {
            try {
                if (this.mainPanel) {
                    this.mainPanel.showLoadingPanel();
                } else {
                    setTimeout(() => this.mainPanel.showLoadingPanel(), 1500);
                }
            } catch (e) {
                //console.log("Loading progress could not been shown", e.message);
            }
        }

        hideLoadingPanel() {
            try {
                if (this.mainPanel) {
                    this.mainPanel.hideLoadingPanel();
                } 
                setTimeout(() => this.mainPanel.hideLoadingPanel(), 1500);
            } catch (e) {
                //console.log("Loading progress could not been shown", e.message);
            }
        }

        onMainPanelReady(ctrl) {
            this.mainPanel = ctrl;
        }

        exportData() {
            // prepare data 
            this.ppTransactions = [];
            var accsIds: number[] = []

            for (let accountId in this.ppTransactionsForAccount) {
                accsIds.push(+accountId);
                this.ppTransactionsForAccount[accountId].forEach((account) => {
                    var tmp = account;

                    if (tmp.newValue) {
                        var newVal = tmp.newValue - (tmp.contributions || 0) + (tmp.withdrawals || 0);
                        var newRec = { ...tmp, accountId: tmp.accountId, newValue: newVal, contributions: null, withdrawals: null, export: 1 };
                        this.ppTransactions.push(newRec);
                    }
                    if (tmp.contributions) {
                        var newRec2 = { ...tmp, accountId: tmp.accountId, newValue: null, withdrawals: null, export: 1 };
                        this.ppTransactions.push(newRec2);
                    }
                    if (tmp.withdrawals) {
                        var newRec3 = { ...tmp, accountId: tmp.accountId, newValue: null, contributions: null, export: 1 };
                        this.ppTransactions.push(newRec3);
                    }
                    
                })
            }

            var dgExp = $("#dgExport").dxDataGrid("instance") as DevExpress.ui.dxDataGrid;
            
            window.setTimeout(() => {
                dgExp.exportToExcel(false);
                //console.log(`Account IDs for update:`, accsIds);

                this.servicerService
                    .updateManualAccountsExportedDate(accsIds)
                    .then(resp => {
                        // localy update exported dates
                        this.accounts
                            .filter(f => f.newValue || f.contributions || f.withdrawals)
                            .forEach(m => m.lastExported = new Date());
                }, err => this.gs.showError(err));
            }, 100);
        }

        firmChanged(): void {
            if (this.selFirm && this.selFirm.id) {
                this.loadManualAccounts(this.selFirm.id);
            } else {
                this.accounts = [];
            }
        }
        

        $onInit(): void {
            this.advisoryFirmApi.getAdvisoryFirmsLight()
                .then(response => {
                    this.advisoryFirms = response.data;
                    if (this.advisoryFirms.length > 0) {
                        this.selFirm = this.advisoryFirms[0];
                        this.firmChanged();
                    }
                }, err => {
                    //console.log(`Advisory firms cannot be loaded. Error: ${err.data}`);
                });
            this.gs.getLOVs()
                .then((data) => {
                    this.updateFrequencies = data.filter(v => v.lovType == domains.LovType.UPDATE_FREQUENCY);
            })
        }

        $onChanges(evt): void {
            //for (var key in evt) {
            //}
        }
        
    }
    
    class ManualAccountsExport implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
            };
            this.controller = ManualAccountsExportController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/manual-accounts-export.html";
        }
    }
    angular.module(Constants.APP).component("manualAccountsExport", new ManualAccountsExport());

}
